import React, { FC } from 'react';
import classNames from 'classnames';
import ProductList from '../../shared/common/ProductList';
import Pagination from '../../shared/common/Pagination';
import GroupedItemActionButton from './GroupedItemActionButton';
import CartProductTile from './CartProductTile';
import CartListItem from './CartListItem';
import { GroupedByItemProps } from '../../shared/common/GroupedByList';
import { isBundleGroupItem } from '../../../models/GroupItem';
import { useTranslation } from 'react-i18next';

export const CartSelectionlistItem: FC<GroupedByItemProps> = props => {
    const { t } = useTranslation();
    const list = props.item;

    if (isBundleGroupItem(list)) {
        throw new Error('<CartSelectionlistItem> can not render grouped by bundle items');
    }

    const isExpanded = list.id === props.grouping.id;

    const classNamesExpand = classNames('material-icons', 'md-normal', 'expand-arrow', { hidden: isExpanded });
    const classNamesCollapse = classNames('material-icons', 'md-normal', 'expand-arrow', { hidden: !isExpanded });

    return (
        <div className="item">
            <div className="selectionlist-item-tile">
                <div className="tc tcw-25 bgreen cold-white txt-normal strong" style={{ minWidth: '160px' }}>
                    {list.listName}
                </div>
                <div className="tc tcw-15 txt-normal strong" style={{ minWidth: '140px' }}>
                    <div>
                        {list.eaudiobookProductAmount
                            ? t('loanFormat.plainWithCount', {
                                  count: list.eaudiobookProductAmount ?? 0,
                                  context: 'eaudiobooks'
                              })
                            : null}
                    </div>
                    <div>
                        {list.ebookProductAmount
                            ? t('loanFormat.plainWithCount', {
                                  count: list.ebookProductAmount ?? 0,
                                  context: 'ebooks'
                              })
                            : null}
                    </div>
                    <div>
                        {list.epressProductAmount
                            ? t('loanFormat.plainWithCount', {
                                  count: list.epressProductAmount ?? 0,
                                  context: 'epress'
                              })
                            : null}
                    </div>
                </div>
                <div className="tc tcw-25">
                    {(list.eaudiobookProductAmount ?? 0) > 0 ? (
                        <div>
                            {t('bundles.alreadyInYourLibrary', {
                                amount: list.eaudiobookProductStockAmount || 0
                            })}
                        </div>
                    ) : null}
                    {(list.ebookProductAmount ?? 0) > 0 ? (
                        <div>
                            {t('bundles.alreadyInYourLibrary', {
                                amount: list.ebookProductStockAmount || 0
                            })}
                        </div>
                    ) : null}
                    {(list.epressProductAmount ?? 0) > 0 ? (
                        <div>
                            {t('bundles.alreadyInYourLibrary', {
                                amount: list.epressProductStockAmount || 0
                            })}
                        </div>
                    ) : null}
                </div>
                <div className="tc tcw-20" style={{ minWidth: '205px' }}>
                    <a onClick={() => props.onToggleList?.(list.id)} className="expand no-user-select">
                        {t('selectionList.groupedByItem.showTitles')}
                        {list.ebookCopyAmount ? (
                            <span className="marker-badge margin smoky display-inline-flex">
                                <i className="bolinda-icons">book</i>
                                <span>{list.ebookCopyAmount}</span>
                            </span>
                        ) : null}
                        {list.eaudiobookCopyAmount ? (
                            <span className="marker-badge margin smoky display-inline-flex">
                                <i className="bolinda-icons">audiobook</i>
                                <span>{list.eaudiobookCopyAmount}</span>
                            </span>
                        ) : null}
                        {list.epressCopyAmount ? (
                            <span className="marker-badge margin smoky display-inline-flex gild">
                                <i className="icon emagazine-filled" />
                                <span>{list.epressCopyAmount}</span>
                            </span>
                        ) : null}
                        <i className={classNamesExpand}>keyboard_arrow_down</i>
                        <i className={classNamesCollapse}>keyboard_arrow_up</i>
                    </a>
                </div>
                <div className="tc tcw-15 actions">
                    <GroupedItemActionButton
                        item={list}
                        className="fl-right"
                        onRemove={props.onRemoveGroupedItemFromList}
                    />
                </div>
            </div>
            {isExpanded ? (
                <div className="item-products">
                    <Pagination
                        totalItems={props.totalProducts}
                        onPageChange={props.onPageChange}
                        currentPage={props.currentPage}
                        pageSize={props.pageSize}
                    />
                    <ProductList
                        {...props}
                        displayType={props.displayType}
                        tileItemComponent={CartProductTile}
                        listItemComponent={CartListItem}
                        onCreateNewListClicked={props.onCreateNewListClicked}
                        currentPage={props.currentPage}
                    />
                    <Pagination
                        totalItems={props.totalProducts}
                        onPageChange={props.onPageChange}
                        currentPage={props.currentPage}
                        pageSize={props.pageSize}
                        placeholder={true}
                    />
                </div>
            ) : null}
        </div>
    );
};
